///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { GtthAbstractCommand } from '../../abstract-command';
import { ActivityDTO } from '../../../../../services/project-socket/activity-dto.model';

export class GtthOpenProjectCommand extends GtthAbstractCommand {
    private newSessionId: string;
    private oldSessionId: string;

    getCommandName(): string {
        return 'GtthOpenProjectCommand';
    }

    getNewSessionId(): string {
        return this.newSessionId;
    }

    create(oldSessionId: string): this {
        this.oldSessionId = oldSessionId;
        return this;
    }

    doCommandActivity(activityDTO: ActivityDTO): void {
        if (!activityDTO.successful) {
            if (activityDTO?.error?.message) {
                this.historyService.notificationService.showError(activityDTO.error.message);
            }
            this.commandResolve(false);
        } else {
            this.newSessionId = activityDTO.sessionId;
            this.commandResolve(true);
        }
    }

    protected doCommand(): void {
        const openProjectActivity = this.createActivityDTO(false);
        openProjectActivity.oldSessionId = this.oldSessionId;
        this.sendActivity(openProjectActivity);
    }
}
